export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Répéter l'opération"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Historique des opérations"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liste des comptes"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur inconnue"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liste des jetons"])}
}